














import { Component, Prop, Vue } from "vue-property-decorator";

import BreadcrumbArea from "@/components/common/breadcrumb/BreadcrumbArea.vue";
import BreadcrumbItem from "@/components/common/breadcrumb/BreadcrumbItem.vue";
import BreadcrumbSep from "@/components/common/breadcrumb/BreadcrumbSep.vue";
import { RouteName } from "@/consts/route";

export interface BreadcrumbData {
  name: string;
  route?: RouteName;
  params?: { [key: string]: string };
  path?: string;
  hash?: string;
  clickable?: boolean;
}

@Component({
  components: { BreadcrumbSep, BreadcrumbItem, BreadcrumbArea },
})
export default class BreadcrumbList extends Vue {
  @Prop({ required: true }) private items!: BreadcrumbData[];

  private onClick(item: BreadcrumbData, index: number): void {
    if (!item.route) {
      return;
    }

    if (item.route === RouteName.Home) {
      // 以下の処理でないと上手くいかない: サービス概要 => ホーム => サービス概要（Hybrid IT）
      this.$router.push({ path: "/r/" + RouteName.Home });
      return;
    }

    const route: BreadcrumbData = {
      name: item.route,
    };

    if (item.params) {
      route["params"] = item.params;
    }

    if (item.hash) {
      route["hash"] = item.hash;
    }

    this.$router.push(route);
  }
}
